import PropTypes from 'prop-types';
import React from 'react';
import { articlePropTypes } from 'app/selectors/support';

import './article-card.less';

const ArticleCard = ({ article, onClick }) => {
  const { fields: { title, description, thumbnail, id } } = article;
  const getThumbnail = () => {
    if (!thumbnail) return { fileName: null, url: null };
    const { fields: { file: { fileName, url } } } = thumbnail;
    return { fileName, url };
  };
  const { fileName, url } = getThumbnail();

  return (
    <div className='card' role='button' tabIndex={0} onClick={() => onClick(id)}>
      <img className='card-img' src={url} alt={fileName} />
      <div className='card-text'>
        <h1 className='card-title'>{title}</h1>
        <p className='card-description'>{description}</p>
      </div>
    </div>
  );
};

ArticleCard.propTypes = {
  article: PropTypes.shape(articlePropTypes),
  onClick: PropTypes.func.isRequired,
};

ArticleCard.defaultProps = {
  article: {},
};

export default ArticleCard;



// WEBPACK FOOTER //
// ./app/components/setup/article-card.jsx